export default {
  "content": "<path d=\"M19 10a2 2 0 11-.001 4.001A2 2 0 0119 10zM12 10a2 2 0 11-.001 4.001A2 2 0 0112 10zM7 12a2 2 0 10-4.001.001A2 2 0 007 12z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};